/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const PRR = {
  HEADER: 'Header',
  RENT_RANGES: 'Rent Ranges',
  AVG_RENT: 'Average Rent',
  DISCOVER_HOODS: 'Discover Neighborhoods',
  RENTAL_MARKET: 'Rental Market',
  AFFORDABLE_LISTINGS: 'Affordable Listings',
  PET_FRIENDLY_LISTINGS: 'Pet Friendly Listings',
  SHORT_TERM_LISTINGS: 'Short Term Listings',
  SEE_MORE: 'See More Reports',
  DISCOVER_REPORTS: 'Discover Reports',
} as const

export const PA = {
  TABLE: 'Table',
  NEARBY: 'Nearby Listings',
  DESCRIPTION: 'Description',
  NEARBY_MAP: 'Map',
  HOOD_GUIDE: 'Neighborhood Guide',
  AVG_RENT: 'Average Rent - Overview',
  MESSAGE_FORM: 'Message Form',
} as const

export const MAPLIST = {
  AVG_RENT_HOODS: 'Average Rent',
  BLOG_ARTICLES: 'Blog Listings',
  CATEGORIES_RESULTS: 'Categories - Results',
  COMPARE_HOODS: 'Rent Research',
  CONTEXT_FOOTER: 'Contextual Footer',
  COST_OF_LIVING: 'Cost of Living',
  DEMOGRAPHICS: 'Demographics',
  DISCOVER: 'Neighborhoods',
  EMPLOYMENT: 'Employment & Economy',
  FAQ: 'FAQ',
  FOOTER_COLUMNS: 'Linkpacks',
  GETTING_AROUND: 'Transportation',
  LOCATION_GUIDE: 'Location Guide',
  LOCATION_OVERVIEW: 'Location Overview',
  NEARBY_MOVING_STORAGE: 'Moving Companies',
  NEARBY_ZIPCODES: 'Nearby Zipcodes',
  PARTNER_LINK: 'Partner Link',
  POP_HOODS: 'Popular Neighborhoods',
  PROPERTY_TYPES: 'Property Types',
  RENT_PRICES: 'Rent Prices',
  RENTAL_PROCESS: 'Rental Process',
  SATISFACTION_SURVEY_RESULTS: 'Satisfaction Survey Results',
  SCHOOL_WIDGET: 'Schools',
  STR_INTERTITIAL: 'STR Interstitial',
  TIPS: 'Tips',
  TOP_POI: 'Things to Do',
  ZUMPER_GUIDE_HOUSEHOLDS: 'Households',
  METHODOLOGY: 'Methodology',
} as const

export const DETAIL = {
  ABOUT: 'About',
  ABOUT_MANAGEMENT: 'About Management',
  AMENITIES: 'Amenities',
  APARMENT_CONTACT: 'Apartment Contact',
  BOTTOM_MESSAGE: 'Bottom Message',
  BUILDING_DETAILS: 'Building details',
  CONTACT: 'Contact',
  CONTACT_BOTTOM: 'Contact (bottom)',
  CONTACT_TOP: 'Contact (top)',
  DETAIL_FAQ: 'FAQ - Details',
  EXPLORE_THE_AREA: 'Explore the area',
  FAQ: 'FAQ',
  FLOORPLAN_MODAL: 'Floorplan modal',
  FLOORPLANS_FULL: 'Floorplans (full)',
  FLOORPLAN_SUMMARY: 'Floorplan summary',
  FLOOR_PLANS: 'Floor Plans',
  HIGHLIGHTS: 'Highlights',
  LOCATION: 'Location',
  MANAGED_BY: 'Managed by',
  NEARBY_MAP: 'Map',
  OFFER: 'Offer',
  PETS_POLICIES_FEES_DETAILS: 'Pets, Policies, Fees, Details',
  POI: 'POI',
  POI_MAP: 'POI Map',
  POLICIES_AND_FEES: 'Policies and Fees',
  PROPERTY_DETAILS: 'Property Details',
  PROS_CONS: 'Pros & Cons',
  RELATED_PROPERTIES: 'Related Properties',
  RENT_SPECIAL: 'Rent Special',
  RENT_TRENDS: 'Rent Trends',
  RENT_HISTORY: 'Rent History',
  SHORT_TERM_BOOKING: 'Short Term Booking',
  SIMILAR_PROPERTIES: 'Similar properties',
  TOUR: 'Tour',
  TOUR_SECTION_BOTTOM: 'Tour section (bottom)',
  TRANSPORTATION: 'Transportation',
} as const

export const SWITCH_LEASE_LENGTH_SECTION = {
  INTERSTITIAL: 'Interstitial',
  SEARCH: 'Search',
  GLOBAL_NAV: 'Global Nav',
} as const

export const DIL = {
  BY_AMENITIES: 'DIL By Amenities',
  BY_BEDROOMS: 'DIL By Bedrooms',
  NEARBY_ADDRESSES: 'DIL Nearby Addresses',
  NEARBY_CITIES: 'DIL Nearby Cities',
  NEARBY_HOODS: 'DIL Nearby Hoods',
  NEARBY_BUILDINGS: 'DIL Nearby Buildings',
} as const

export const HOMEPAGE = {
  EXPLORE_RENTALS: 'Explore Rentals',
  POPULAR_CITIES: 'Popular Cities',
  APP_DOWNLOAD: 'App Download',
  LIST_YOUR_PROEPRTY: 'List Your Property',
  LINKPACKS: 'Linkpacks',
  PRESS: 'Press',
  RENT_REPORT: 'National Rent Report',
  FAQ: 'FAQ',
} as const

export const HOMEPAGE_ZUMPER_RENTALS = {
  EXPLORE_RENTALS_ZUMPER_RENTALS: 'Explore Rentals - Zumper Rentals',
  POPULAR_CITIES_ZUMPER_RENTALS: 'Popular Cities - Zumper Rentals',
  APP_DOWNLOAD_ZUMPER_RENTALS: 'App Download - Zumper Rentals',
  LIST_YOUR_PROEPRTY_ZUMPER_RENTALS: 'List Your Property - Zumper Rentals',
  LINKPACKS_ZUMPER_RENTALS: 'Linkpacks - Zumper Rentals',
  PRESS_ZUMPER_RENTALS: 'Press - Zumper Rentals',
  FAQ_ZUMPER_RENTALS: 'FAQ - Zumper Rentals',
} as const
